import { PaywallV8 } from '@/pages/paywall/v8';

export function PaywallV9() {
  return <PaywallV8 layout="responsive" version="v9" />;
}
